// Class strings for the shared Pill primitive. Kept in a non-component module
// so they can be shared (and unit-tested) without tripping the react-refresh
// only-export-components rule on Pill.tsx.

export type PillVariant = 'outline' | 'selected';

// Pill / chip text raised from 11px to 12px (approved darker/larger type pass,
// 2026-06) so chip text reads at the new small-text floor.
export const PILL_BASE =
  'inline-flex items-center gap-1.5 rounded-pill px-2.5 py-1 text-[12px] font-semibold whitespace-nowrap transition-colors duration-fast ease-out';

export const PILL_VARIANT: Record<PillVariant, string> = {
  outline:
    'border border-amp-line bg-transparent text-amp-ink dark:border-amp-dark-line dark:text-amp-dark-ink',
  // olive-deep (#7A6B45) fill + cream text -> high contrast in both modes.
  selected:
    'border border-transparent bg-amp-olive-deep text-amp-cream dark:bg-amp-olive-deep dark:text-amp-cream',
};

// A semantic ("tinted") pill reuses PILL_BASE for its shape, size, padding, and
// weight, then layers a caller-supplied tone (background + text color classes)
// on top. This is how status / ship / health / stage pills stay one pill family
// while keeping the meaning their color carries. Callers pass the tone via the
// Pill `tone` prop; the color maps live with each page (STATUS_TONES, etc.).
// The tone string owns the bg/text color in both light and dark mode; the base
// owns everything else, so every tinted pill matches the shared shape.
export function tintedPillClass(tone: string, className?: string): string {
  return `${PILL_BASE} ${tone}${className ? ` ${className}` : ''}`;
}
